import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { FiSun, FiMoon } from "react-icons/fi";
import { useTheme } from "../ThemeContext";
import Contact from "./Contact";

const links = [
  { label: "Home", to: "/" },
  { label: "Projects", to: "/projects" },
  { label: "Blogs", to: "/blogs" },
  { label: "Community", to: "/community" },
];

const navLinkClass = ({ isActive }) =>
  `shrink-0 rounded-full px-2.5 py-2 text-xs font-medium transition-colors duration-100 sm:px-4 sm:text-sm ${
    isActive ? "bg-fg text-bg" : "text-muted hover:text-fg"
  }`;

const Navbar = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const [contactOpen, setContactOpen] = useState(false);
  const contactRef = useRef(null);
  const contactButtonRef = useRef(null);

  useEffect(() => {
    if (!contactOpen) return undefined;

    const handlePointerDown = (event) => {
      if (!contactRef.current?.contains(event.target)) {
        setContactOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setContactOpen(false);
        contactButtonRef.current?.focus();
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [contactOpen]);

  return (
    <header className="sticky top-0 z-50 px-4 pt-4 sm:px-6">
      <nav
        className="mx-auto flex max-w-content items-center justify-between gap-2 rounded-full border border-line bg-surface/90 px-3 py-2 shadow-sm backdrop-blur"
        aria-label="Main"
      >
        {/* <NavLink
          to="/"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-line font-mono text-xs font-semibold"
          aria-label={`${profile.name} — home`}
        >
          {initials}
        </NavLink> */}

        <div className="flex flex-1 items-center justify-start gap-0.5 overflow-x-auto no-scrollbar sm:gap-1">
          {links.map((link) => (
            <NavLink key={link.to} to={link.to} end className={navLinkClass}>
              {link.label}
            </NavLink>
          ))}
        </div>

        <div ref={contactRef} className="relative shrink-0">
          <button
            ref={contactButtonRef}
            type="button"
            onClick={() => setContactOpen((open) => !open)}
            aria-haspopup="true"
            aria-expanded={contactOpen}
            className="rounded-full bg-fg px-3 py-2 text-xs font-semibold text-bg transition-opacity duration-100 hover:opacity-80 sm:px-4 sm:text-sm"
          >
            Contact
          </button>
          {contactOpen && (
            <div className="absolute right-0 top-full z-50 mt-2">
              <Contact />
            </div>
          )}
        </div>

        <button
          type="button"
          onClick={toggleTheme}
          aria-label={
            isDarkMode ? "Switch to light theme" : "Switch to dark theme"
          }
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-line text-muted transition-colors duration-100 hover:text-fg"
        >
          {isDarkMode ? (
            <FiSun className="h-4 w-4" aria-hidden="true" />
          ) : (
            <FiMoon className="h-4 w-4" aria-hidden="true" />
          )}
        </button>
      </nav>
    </header>
  );
};

export default Navbar;
